<template>
  <div>
    <v-row>
      <v-col cols="12" md="12">
        <v-btn @click="test">
          test
        </v-btn>
      </v-col>
    </v-row>
  </div>

</template>

<script>

import {MFormMixin} from "@/components/m-form";
import FormsMixin from "@/mixin/forms";
import {PathLevels, VisitorLevels} from "@/variables";
import formsMixin from "@/mixin/forms";
import money from "@/components/mcomponents/cleave/Money";
import cart from "@/components/scomponents/Cart";
import UserSelect from "@/components/selects/UserSelect";


export default {
  name: "TestAffiliate",
  mixins: [MFormMixin, formsMixin, FormsMixin],
  components: {
    UserSelect,
    cart
  },

  props: {
    id: {},
  },
  data() {
    return {
      printUrl: 'affiliate/factor/all',
      baseUrl: "affiliate/factorCreate",
      permissionBasename: "affiliate_factor",
      appendSlash: false,
      hasList: false,
      no_edit_dialog: false,
      hasIdProp: true,
      show_setting: false,
      hasLock: false,
      error_dialog: false,
      error_message: null,
      isDefinable: false,
      myClass: '',
      ss: null,
      PathLevels,
      VisitorLevels,
      paymentDialog: false,
      payment: '',
      performClearForm: true,
      items: [],
      first: false,
      cols: [
        {
          text: "نام کسب و کار",
          value: "business.name",
        },
        {
          text: "نام مشتری",
          value: "customer_name",
        },
        {
          text: "تلفن",
          value: "phone",
        },
        {
          text: "آدرس",
          value: "address",
        },
        {
          text: "وضعیت",
          value: "status_display",
        },
      ],

    };
  },
  computed: {
    title() {
      return 'تست'
    },
    headers() {
      return [];
    },
  },
  updated() {
  },
  created() {
  },
  methods: {
    test() {
      this.request({
        url: this.endpoint(`affiliate/factorCreate?businessToken=26ced921b892b35db3bafff80e2ffdcb73ba52916c13e6011bb623ed3d41f65c5eebaa39ddfb6ed111a26735fa6ee97cdfb1`),
        method: "post",
        data: {
          "customer_name": "John Doe",
          "phone": "09366785638",
          "address": "123 Main St",
          "postal_code": "7185253213",
          "products": [
            {"product_code": 14581, "quantity": 2, "price": 1000},
            {"product_code": 14550, "quantity": 3, "price": 2000},
          ]
        }
        ,
        success: (data) => {
          console.log(data)
        },
      });
    },
    testRetrieve() {
      this.request({
        url: this.endpoint(`affiliate/productsRetrieve?businessToken=${this.user.business_token}`),
        method: "get",
        success: (data) => {
          console.log(data)
        },
      });
    },
    testReceiveProductsInventory() {
      this.request({
        url: this.endpoint(`affiliate/receiveProductsInventory?businessToken=31fe4ca22e6d9ac6d17de6a9371ea6f7f60fe197d41cd441eb7a6ade2f1aa86cb89f6445a8e3127cb40dfc86be0bec2cd8de`),
        method: "get",
        success: (data) => {
          console.log(data)
        },
      });
    },


  },
}
</script>

<style scoped lang="scss"></style>

